export default "__VITE_ASSET__D3x0_SAc__"